import { AuthenticationService } from "./Authentication/authenticationService";

export default class Request extends AuthenticationService {

}
